import type { WorkingHours } from '../../../common/business-hours-types';
import { timeRangeToDateRange } from '../../../utils/time-range-to-date-range';
import { unionTupleDates } from '../../utils/union-tuple-dates';

// @TODO add TZ offset

export const getWorkHoursIntervalsForDate = (
  hours: WorkingHours[] = [],
  givenDate: Date,
  withUnion = true
) => {
  const tupleArray = hours.map(({ timeRange }) =>
    timeRangeToDateRange(timeRange, givenDate)
  );

  if (tupleArray.length > 1 && withUnion) {
    return unionTupleDates(tupleArray);
  }

  return tupleArray;
};
